export default import.meta.ROLLUP_FILE_URL_Xqy2qDT4PzrKN8VHc5MYXg